import { Children, isValidElement, cloneElement, useState } from 'react';
import { Box } from 'modules/v2/foundation/Box';
import { Popover } from 'modules/v2/navigation/Popover';
import { AvatarGroup } from './AvatarGroup';
export function AvatarList(props) {
    const { limit = 3, children, size = 'sm' } = props;
    const [open, setOpen] = useState(false);
    const childrenCount = Children.count(children);
    if (childrenCount <= 1) {
        return (<AvatarGroup size={size} limit={limit}>
        {children}
      </AvatarGroup>);
    }
    const popoverChildren = Children.toArray(children).map((child) => {
        if (isValidElement(child)) {
            return cloneElement(child, { size: 'xs' });
        }
        return child;
    });
    return (<Popover open={open} onClose={() => setOpen(false)} shadow="300" padding="lg" target={<AvatarGroup size={size} limit={limit} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
          {children}
        </AvatarGroup>}>
      <Box gap="md" flexDirection="column">
        {popoverChildren}
      </Box>
    </Popover>);
}
